import { AxiosRequestConfig } from "axios";

import type { File } from "@supplier/entity";

import { BaseService } from "@/api/baseService";
import httpRequest from "@/api/index";

// 文件服务
export class FileService extends BaseService<any, any, any, any> {
    public async uploadFile(params: FormData, isNotShowLoading?: boolean = false): Promise<File> {
        const { data } = await this.service.post(`${this.path}/upload`, params, {
            cancel: true,
            isNotShowLoading
        } as unknown as AxiosRequestConfig);
        return data;
    }

    public async getFileById(id: number): Promise<File> {
        const { data } = await this.service.get(`${this.path}/${id}`);
        return data;
    }

    public async getFileByIds(ids: number[]): Promise<File[]> {
        const { data } = await this.service.post(`${this.path}/ids`, ids);
        return data;
    }

    public async findById(id: number): Promise<File> {
        const { data } = await this.service.get(`${this.path}/${id}`);
        return data;
    }
}
export const fileService = new FileService("/file", httpRequest, { cancel: true });
